
import { useSelector  } from 'react-redux';

export default function useToken() {

    const token = useSelector(state => {
        return (state.auth.data  && state.auth.data.user)
            ? state.auth.data.user.token
            : null;
    });

    return token;
}
